import { useCallback } from 'react'
import { useAppStore } from '../../apps/app-store-provider'

const useFetchRemoteData = function () {
  const getDitto = useAppStore((x) => x.getDitto)
  return useCallback(
    (type, props) => {
      return getDitto(type, props)
    },
    []
  )
}

export default useFetchRemoteData
